import { FC } from "react";

interface Props {
  className?: string;
}

const ProgramPageFrame: FC<Props> = ({ className }) => {
  return (
    <svg
      width="486"
      viewBox="0 0 486 311"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M417.42 186.091C445.782 189.131 467.422 201.983 472.35 221.615C479.889 251.642 445.476 286.158 395.488 298.708C380.543 302.46 365.898 303.823 352.508 303.089"
        stroke="#202123"
        strokeWidth="1.52846"
      />
      <path
        d="M352.415 296.737L353.016 299.832C353.254 301.056 354.211 302.012 355.434 302.25L358.529 302.851L355.434 303.452C354.211 303.69 353.254 304.647 353.016 305.87L352.415 308.965L351.814 305.87C351.577 304.647 350.62 303.69 349.396 303.452L346.302 302.851L349.396 302.25C350.62 302.012 351.577 301.056 351.814 299.832L352.415 296.737Z"
        fill="#202123"
      />
      <path
        d="M337.897 281.453L339.244 288.387C339.482 289.611 340.438 290.567 341.662 290.805L348.597 292.152L341.662 293.499C340.438 293.736 339.482 294.693 339.244 295.917L337.897 302.851L336.55 295.917C336.313 294.693 335.356 293.736 334.132 293.499L327.198 292.152L334.132 290.805C335.356 290.567 336.313 289.611 336.55 288.387L337.897 281.453Z"
        fill="#202123"
      />
      <circle
        cx="460.937"
        cy="260.054"
        r="5.34962"
        fill="#202123"
        stroke="#FAFAFA"
        strokeWidth="3.05693"
      />
      <g clipPath="url(#clip0_2116_4404)">
        <rect
          x="80.3357"
          y="75.9697"
          width="326.582"
          height="183.375"
          fill="none"
        />
        <path
          d="M409.858 66.3643H77.4051C75.1717 66.3645 73.0299 67.2802 71.4507 68.9099C69.8714 70.5396 68.9841 72.7498 68.9839 75.0545V261.091H80.3357V81.6455C80.3351 81.092 80.1307 79.974 80.3357 79.4625C80.5406 78.951 80.4414 78.1709 80.8207 77.7795C81.1999 77.3881 81.6503 77.0778 82.1459 76.8662C82.6416 76.6547 83.1728 76.5462 83.7092 76.5468H402.826C403.362 76.5462 403.894 76.6547 404.389 76.8662C404.885 77.0778 405.335 77.3881 405.715 77.7795C406.094 78.1709 406.395 78.6356 406.599 79.1471C406.804 79.6586 406.91 80.2068 406.909 80.7603V261.091H418.27V75.0545C418.271 73.9138 418.054 72.7839 417.632 71.7297C417.21 70.6754 416.59 69.7173 415.809 68.9102C415.028 68.1031 414.1 67.4628 413.079 67.026C412.058 66.5891 410.963 66.3643 409.858 66.3643ZM243.628 73.9914C243.228 73.9914 242.837 73.869 242.504 73.6397C242.171 73.4103 241.912 73.0843 241.759 72.7029C241.606 72.3215 241.566 71.9019 241.644 71.497C241.722 71.0921 241.915 70.7202 242.197 70.4283C242.48 70.1364 242.841 69.9376 243.233 69.8571C243.625 69.7765 244.032 69.8179 244.402 69.9758C244.771 70.1338 245.087 70.4013 245.309 70.7446C245.532 71.0878 245.65 71.4914 245.65 71.9042C245.65 72.4576 245.437 72.9882 245.057 73.3795C244.678 73.7708 244.164 73.9909 243.628 73.9914Z"
          fill="black"
        />
        <path
          d="M407.961 271.672H89.1575C84.86 271.672 80.0054 272.129 75.8547 270.905C73.1823 270.069 70.7282 268.669 68.664 266.804C66.5998 264.94 64.9753 262.654 63.9042 260.109L62.025 261.285H419.566C421.183 261.376 422.804 261.376 424.42 261.285C424.626 261.274 424.832 261.274 425.038 261.285L424.274 260.405C421.351 266.937 415.408 271.574 407.961 271.672C407.425 271.679 406.39 271.837 406.168 272.428C405.963 272.971 406.344 273.314 406.932 273.307C411.155 273.308 415.286 272.1 418.821 269.831C422.355 267.562 425.139 264.329 426.831 260.53C427.074 259.987 426.688 259.345 426.128 259.345H77.716C73.011 259.345 68.4495 259.323 63.7446 259.345C64.0749 259.343 63.0774 259.345 62.8713 259.345C62.4319 259.345 60.8187 260.02 61.18 260.827C62.7657 264.522 65.4246 267.676 68.8247 269.895C72.2248 272.115 76.2153 273.301 80.2981 273.307C81.511 273.316 82.7249 273.307 83.9388 273.307H392.71C397.253 273.307 401.796 273.328 406.338 273.307C406.536 273.307 406.735 273.307 406.932 273.307C407.466 273.307 408.505 273.139 408.72 272.552C408.932 272.002 408.547 271.672 407.961 271.672Z"
          fill="#050505"
        />
        <path
          d="M226.285 265.567H259.368C263.631 265.567 267.92 263.953 270.221 260.246C270.447 259.877 269.562 259.883 269.45 259.883H219.255C219.027 259.883 217.003 260.326 217.314 260.827C218.233 262.273 219.511 263.467 221.029 264.297C222.546 265.126 224.253 265.563 225.989 265.567C226.672 265.616 227.351 265.437 227.918 265.06C228.258 264.764 228.352 264.413 227.737 264.399C226.19 264.377 224.674 263.972 223.329 263.222C221.984 262.473 220.853 261.402 220.041 260.109L218.099 261.052H268.294L267.524 260.69C266.891 261.783 265.983 262.698 264.886 263.348C263.79 263.998 262.541 264.36 261.262 264.399C260.876 264.405 260.49 264.399 260.104 264.399H227.441C226.962 264.399 225.883 264.602 225.622 265.057C225.339 265.549 225.865 265.567 226.285 265.567Z"
          fill="#050505"
        />
        <path
          d="M425.134 273.316H406.28C411.167 273.316 418.243 269.801 421.17 268.044L425.83 270.427C427.26 271.158 426.74 273.316 425.134 273.316Z"
          fill="black"
        />
      </g>
      <path
        d="M437.836 165.013C439.265 168.405 435.918 172.751 435.937 176.217C435.958 179.809 439.304 184.123 437.971 187.399C436.638 190.675 431.228 191.422 428.705 193.979C426.27 196.446 425.63 201.894 422.238 203.323C418.846 204.753 414.499 201.405 411.034 201.425C407.442 201.445 403.127 204.791 399.851 203.458C396.576 202.126 395.829 196.716 393.271 194.192C390.804 191.758 385.356 191.117 383.927 187.725C382.497 184.333 385.845 179.986 385.825 176.521C385.805 172.929 382.458 168.616 383.792 165.339C385.127 162.062 390.535 161.316 393.059 158.758C395.493 156.292 396.134 150.843 399.526 149.414C402.919 147.985 407.264 151.333 410.729 151.313C414.321 151.293 418.635 147.946 421.911 149.279C425.187 150.612 425.934 156.022 428.492 158.546C430.958 160.98 436.407 161.62 437.836 165.013Z"
        fill="#3064C0"
        stroke="white"
        strokeWidth="1.52846"
        strokeMiterlimit="10"
      />
      <path
        d="M434.411 166.455C435.659 169.416 432.736 173.211 432.754 176.236C432.771 179.372 435.693 183.138 434.529 185.998C433.365 188.858 428.643 189.51 426.439 191.743C424.314 193.896 423.755 198.653 420.794 199.901C417.833 201.148 414.038 198.226 411.012 198.243C407.876 198.261 404.11 201.182 401.25 200.019C398.39 198.855 397.738 194.132 395.505 191.929C393.352 189.804 388.595 189.245 387.347 186.283C386.1 183.322 389.022 179.527 389.005 176.502C388.987 173.366 386.065 169.6 387.23 166.74C388.396 163.879 393.117 163.228 395.32 160.995C397.445 158.842 398.004 154.085 400.966 152.837C403.928 151.59 407.721 154.512 410.746 154.495C413.883 154.477 417.649 151.556 420.509 152.719C423.368 153.883 424.021 158.606 426.254 160.809C428.407 162.934 433.164 163.493 434.411 166.455Z"
        fill="#3064C0"
        stroke="white"
        strokeWidth="0.764232"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M413.788 183.051C417.096 181.321 419.157 177.511 418.305 173.403C417.605 170.04 414.9 167.363 411.547 166.677C405.914 165.534 400.931 169.811 400.931 175.259C400.931 178.647 402.848 181.579 405.653 183.038V184.983C405.653 187.216 407.483 189.046 409.721 189.046C411.958 189.046 413.788 187.216 413.788 184.983V183.051ZM406.929 181.406H412.541C415.257 180.177 417.012 177.142 416.33 173.82C415.795 171.251 413.709 169.179 411.145 168.655C406.781 167.767 402.948 171.062 402.948 175.259C402.948 178.008 404.582 180.367 406.929 181.406ZM411.771 183.423H407.67V184.983C407.67 186.1 408.596 187.028 409.721 187.028C410.845 187.028 411.771 186.1 411.771 184.983V183.423Z"
        fill="white"
      />
      <path
        d="M397.431 175.205C397.431 174.64 397.883 174.196 398.44 174.196H398.569C399.126 174.196 399.578 174.64 399.578 175.205C399.578 175.757 399.126 176.214 398.569 176.214H398.44C397.883 176.214 397.431 175.757 397.431 175.205Z"
        fill="white"
      />
      <path
        d="M422.19 175.205C422.19 175.757 421.739 176.214 421.181 176.214H421.083C420.524 176.214 420.074 175.757 420.074 175.205C420.074 174.64 420.524 174.196 421.083 174.196H421.181C421.739 174.196 422.19 174.64 422.19 175.205Z"
        fill="white"
      />
      <path
        d="M401.056 166.449C401.451 166.045 402.089 166.045 402.483 166.449L402.575 166.53C402.969 166.933 402.969 167.565 402.575 167.955C402.181 168.359 401.542 168.359 401.148 167.955L401.056 167.875C400.662 167.471 400.662 166.839 401.056 166.449Z"
        fill="white"
      />
      <path
        d="M418.565 183.948C418.171 184.351 417.532 184.351 417.138 183.948L417.069 183.881C416.675 183.491 416.675 182.845 417.069 182.455C417.463 182.065 418.1 182.065 418.495 182.455L418.565 182.522C418.958 182.912 418.958 183.558 418.565 183.948Z"
        fill="white"
      />
      <path
        d="M418.567 166.449C418.961 166.839 418.961 167.471 418.567 167.875L418.475 167.955C418.081 168.359 417.442 168.359 417.048 167.955C416.654 167.565 416.654 166.933 417.048 166.53L417.139 166.449C417.534 166.045 418.173 166.045 418.567 166.449Z"
        fill="white"
      />
      <path
        d="M401.056 183.948C400.662 183.558 400.662 182.912 401.056 182.522L401.128 182.455C401.522 182.065 402.159 182.065 402.553 182.455C402.948 182.845 402.948 183.491 402.553 183.881L402.483 183.948C402.089 184.351 401.451 184.351 401.056 183.948Z"
        fill="white"
      />
      <path
        d="M409.812 162.817C410.369 162.817 410.821 163.275 410.821 163.826V163.961C410.821 164.512 410.369 164.969 409.812 164.969C409.256 164.969 408.804 164.512 408.804 163.961V163.826C408.804 163.275 409.256 162.817 409.812 162.817Z"
        fill="white"
      />
      <path
        d="M68.5802 142.237C40.2178 139.198 18.5782 126.345 13.6497 106.714C6.11116 76.6863 40.5238 42.1706 90.5124 29.6207C105.457 25.8688 120.102 24.5049 133.492 25.2389"
        stroke="#202123"
        strokeWidth="1.52846"
      />
      <g clipPath="url(#clip1_2116_4404)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M133.71 37.3905L134.486 36.0306C134.793 35.4919 134.605 34.8054 134.066 34.4983C133.527 34.1912 132.841 34.3791 132.534 34.9178L131.758 36.2777C131.451 36.8164 131.639 37.5029 132.178 37.81C132.717 38.1172 133.403 37.9292 133.71 37.3905Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M150.325 20.9461C150.027 21.0278 149.789 21.2248 149.647 21.4733C149.504 21.7245 149.457 22.0272 149.54 22.3275C149.703 22.9261 150.322 23.2785 150.92 23.1146L152.961 22.5537C153.56 22.3885 153.912 21.7704 153.747 21.1723C153.583 20.5737 152.965 20.2213 152.367 20.386L150.325 20.9461Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.373 13.6039L136.814 11.5608C136.65 10.9621 136.032 10.6097 135.433 10.7736C135.135 10.8553 134.897 11.051 134.755 11.3008C134.612 11.552 134.565 11.8547 134.646 12.1543L135.205 14.1974C135.369 14.7961 135.987 15.1485 136.586 14.9846C137.185 14.8206 137.537 14.2025 137.373 13.6039Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M148.848 30.4997C148.541 31.0384 148.729 31.7249 149.267 32.0321L150.569 32.7739C151.107 33.0811 151.794 32.8931 152.101 32.3544C152.408 31.8156 152.22 31.1292 151.681 30.822L150.38 30.0802C149.841 29.773 149.155 29.961 148.848 30.4997Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.288 15.3272L147.063 13.9674C147.37 13.4287 147.182 12.7422 146.644 12.4351C146.105 12.1279 145.418 12.3159 145.111 12.8546L144.336 14.2145C144.029 14.7532 144.217 15.4397 144.755 15.7468C145.294 16.0539 145.981 15.866 146.288 15.3272Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M141.512 35.8027C141.371 36.0512 141.323 36.3565 141.404 36.6548L141.963 38.6993C142.127 39.2979 142.745 39.6503 143.344 39.4864C143.94 39.3231 144.294 38.7077 144.131 38.1078L143.573 36.0634C143.409 35.4647 142.791 35.1123 142.192 35.2762C141.892 35.3572 141.655 35.5529 141.512 35.8027Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M129.98 19.7438C130.287 19.2051 130.099 18.5186 129.56 18.2114L128.259 17.4696C127.72 17.1624 127.034 17.3504 126.727 17.8891C126.42 18.4278 126.607 19.1143 127.146 19.4215L128.447 20.1633C128.986 20.4705 129.673 20.2825 129.98 19.7438Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.644 30.4245L144.273 26.6737C145.032 26.2703 145.454 25.4883 145.372 24.6311C145.29 23.7726 144.73 23.0839 143.921 22.8364L136.827 20.4905C136.004 20.239 135.155 20.4926 134.606 21.1557C134.523 21.2551 134.451 21.3585 134.389 21.4665C134.04 22.0794 134.025 22.8126 134.364 23.4577L135.419 25.4661L134.65 27.9762C134.397 28.7989 134.651 29.6507 135.314 30.1994C135.979 30.7476 136.865 30.8389 137.644 30.4245Z"
          fill="black"
          stroke="white"
          strokeWidth="1.52846"
        />
      </g>
      <path
        d="M39.8484 127.565L44.4619 132.914C45.2759 133.858 46.5816 134.213 47.7616 133.812L54.449 131.536L49.0996 136.149C48.1557 136.963 47.8006 138.269 48.2021 139.449L50.4778 146.137L45.8643 140.787C45.0502 139.843 43.7446 139.488 42.5646 139.89L35.8772 142.165L41.2266 137.552C42.1705 136.738 42.5256 135.432 42.1241 134.252L39.8484 127.565Z"
        fill="#202123"
      />
      <defs>
        <clipPath id="clip0_2116_4404">
          <rect
            width="370.354"
            height="206.952"
            fill="white"
            transform="translate(61.125 66.3643)"
          />
        </clipPath>
        <clipPath id="clip1_2116_4404">
          <rect
            width="35.9495"
            height="37.4474"
            fill="white"
            transform="translate(164.728 18.5466) rotate(119.688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProgramPageFrame;
